import * as tslib_1 from "tslib";
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { onPrintRow } from 'owa-mail-module-orchestrator';
import { lazyPrint, readingPaneStore } from 'owa-mail-reading-pane-store';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
export default action('printItem')(function printItem(itemId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var restrictionToConfirm;
        return tslib_1.__generator(this, function (_a) {
            restrictionToConfirm = { PrintAllowed: true };
            if (confirmItemActionAllowed(itemId.Id, restrictionToConfirm, format(strings.irm_actionNotAllowedOnThisItem, strings.itemHeaderPrint))) {
                lazyPrint.importAndExecute(itemId, function (viewState) {
                    readingPaneStore.itemPrintPaneViewState = viewState;
                } /* Store the viewState as the item print pane viewState in the RP store */);
                onPrintRow();
            }
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=printItem.js.map